import { render } from "./PopoverUi.vue?vue&type=template&id=4ba01c56&ts=true"
import script from "./PopoverUi.vue?vue&type=script&lang=ts"
export * from "./PopoverUi.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__